<!-- eslint-disable vue/no-mutating-props -->
<script>
import JiraAPI from 'dashboard/api/integrations/jira';
import IssueInfosModal from './IssueInfosModal.vue';

export default {
  components: { IssueInfosModal },
  mixins: [],
  props: {
    contact: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      issueTypes: [],
      summary: '',

      selectedIssue: null,
      showIssueInfosModal: false,
    };
  },
  computed: {
    contactIssues() {
      const issues = this.contact.additional_attributes?.jira_issues || [];
      if (!issues.length) return [];

      return issues
        .map(e => ({
          ...e,
          iconUrl: this.issueTypeIconUrl(e.issue_type),
          issueTypeName: this.issueTypeName(e.issue_type),
        }))
        .sort(
          // Ordenação decrescente baseado na chave da issue
          (a, b) =>
            parseInt(b.key?.split('-')[1] || 0, 10) -
            parseInt(a.key?.split('-')[1] || 0, 10)
        );
    },
  },
  mounted() {
    this.fetchIssueTypes();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    async fetchIssueTypes() {
      try {
        const { data } = await JiraAPI.fetchIssueTypes();
        if (!data) throw new Error('Jira API error');
        this.issueTypes = data;
      } catch (e) {
        /* empty */
      }
    },
    issueTypeIconUrl(issueTypeId) {
      return this.issueTypes.find(e => e.id === issueTypeId)?.icon_url;
    },
    issueTypeName(issueTypeId) {
      return this.issueTypes.find(e => e.id === issueTypeId)?.name;
    },
    openIssueInfosModal(issue) {
      this.selectedIssue = issue;
      this.showIssueInfosModal = true;
    },
  },
};
</script>

<template>
  <div>
    <woot-modal-header
      :header-title="
        $t('INTEGRATION_SETTINGS.JIRA.SHOW_TICKET.LIST_ISSUES_MODAL.HEADER')
      "
      :header-content="
        $t(
          'INTEGRATION_SETTINGS.JIRA.SHOW_TICKET.LIST_ISSUES_MODAL.HEADER_CONTENT'
        )
      "
      class="mb-4"
    />
    <div
      class="flex flex-col row justify-center content-box pb-6 px-8 my-0 mx-auto"
    >
      <div class="main-container">
        <div class="w-full flex gap-4 flex-col max-h-[70vh] overflow-y-auto">
          <div v-if="!contactIssues.length" class="text-xs italic text-red-400">
            {{
              $t(
                'INTEGRATION_SETTINGS.JIRA.SHOW_TICKET.LIST_ISSUES_MODAL.NO_TICKETS'
              )
            }}
          </div>
          <div v-else>
            <div
              v-for="issue in contactIssues"
              :key="issue.key"
              class="flex w-full min-h-[3rem] justify-between border border-solid items-center px-4 rounded-md border-slate-100 dark:border-slate-600 cursor-pointer hover:bg-slate-25 dark:hover:bg-slate-700"
              @click="openIssueInfosModal(issue)"
            >
              <div class="flex gap-2 justify-center">
                <img
                  class="w-5 h-5"
                  :src="issue.iconUrl"
                  :alt="issue.issueTypeName"
                />
                <span>{{ issue.key }}</span>
              </div>

              <span class="truncate max-w-[70%]">{{ issue.summary }}</span>

              <woot-button
                size="medium"
                variant="link"
                color-scheme="primary"
                icon="info"
                @click="() => null"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <woot-modal
      v-if="showIssueInfosModal"
      v-model:show="showIssueInfosModal"
      :on-close="() => (showIssueInfosModal = false)"
      size="medium"
    >
      <IssueInfosModal
        :selected-issue="selectedIssue"
        @close="() => (showIssueInfosModal = false)"
      />
    </woot-modal>
  </div>
</template>
